/** Identity and trust, re-exported from `@openvole/volenet` — see ./index.ts for why. */
export * from '@openvole/volenet'
